import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [RouterLink],
  template: `
    <footer>
      <div class="footer-accent"></div>
      <div class="container">
        <div class="footer-grid">
          <div class="footer-brand">
            <a routerLink="/home" class="logo">
              <img src="assets/images/logo/logo-text-no-bg.png" alt="SAI" class="logo-img" width="120" height="32" />
            </a>
            <p>The central intelligence layer that transforms organizations into fully AI-native enterprises, where humans and intelligent agents operate as one.</p>
            <div class="social-links">
              <a href="https://www.facebook.com/profile.php?id=100091740162831" target="_blank" rel="noopener" aria-label="Facebook">
                <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
              </a>
              <a href="https://www.instagram.com/nuwatt_tech/" target="_blank" rel="noopener" aria-label="Instagram">
                <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
              </a>
              <a href="https://www.linkedin.com/company/86832834/" target="_blank" rel="noopener" aria-label="LinkedIn">
                <svg width="20" height="20" fill="currentColor" viewBox="0 0 24 24"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
              </a>
            </div>
          </div>

          <div class="footer-links">
            <h4>Company</h4>
            <a routerLink="/about">About SAI</a>
            <a routerLink="/agents">SAI Agents</a>
            <a routerLink="/contact">Contact Us</a>
          </div>

          <div class="footer-links">
            <h4>Resources</h4>
            <a routerLink="/faq">FAQs</a>
            <a routerLink="/privacy">Privacy Policy</a>
            <a routerLink="/terms">Terms & Conditions</a>
          </div>

          <div class="footer-links">
            <h4>Contact</h4>
            <p class="contact-item">
              <svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg>
              +966-574350422
            </p>
            <p class="contact-item">
              <svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
              sai&#64;nuwatt.tech
            </p>
            <p class="contact-item">
              <svg width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>
              Jeddah, Saudi Arabia
            </p>
          </div>
        </div>

        <div class="footer-bottom">
          <p>&copy; {{ currentYear }} SAI. All Rights Reserved.</p>
          <p>Powered by <a href="https://nuwatt.tech/" target="_blank" rel="noopener">Nuwatt Technovation</a></p>
        </div>
      </div>
    </footer>
  `,
  styles: `
    footer {
      position: relative;
      background: var(--bg-secondary);
      border-top: 1px solid var(--border-card);
      padding: 80px 0 30px;
      overflow: hidden;
    }

    .footer-accent {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 3px;
      background: var(--gradient-accent);
    }

    .footer-grid {
      display: grid;
      grid-template-columns: 2fr 1fr 1fr 1.2fr;
      gap: 48px;
      margin-bottom: 60px;
    }

    .footer-brand {
      .logo {
        display: inline-flex;
        align-items: center;
        margin-bottom: 16px;

        .logo-img {
          height: 32px;
          width: auto;
          max-width: 140px;
          object-fit: contain;
          display: block;
        }
      }

      > p {
        color: var(--text-muted);
        font-size: 0.95rem;
        line-height: 1.7;
        margin-bottom: 24px;
        max-width: 300px;
      }
    }

    .social-links {
      display: flex;
      gap: 12px;

      a {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        border-radius: 10px;
        background: var(--bg-primary);
        border: 1px solid var(--border-card);
        color: var(--text-muted);
        transition: all 0.3s ease;

        &:hover {
          background: rgba(57, 158, 244, 0.06);
          color: var(--accent-blue);
          border-color: rgba(57, 158, 244, 0.3);
          transform: translateY(-2px);
        }
      }
    }

    .footer-links {
      h4 {
        font-size: 0.9rem;
        font-weight: 600;
        color: var(--text-primary);
        margin-bottom: 20px;
        text-transform: uppercase;
        letter-spacing: 1px;
      }

      a, .contact-item {
        display: flex;
        align-items: center;
        gap: 8px;
        color: var(--text-muted);
        font-size: 0.9rem;
        margin-bottom: 12px;
        transition: color 0.3s ease;
      }

      a:hover { color: var(--accent-blue); }
    }

    .footer-bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 30px;
      border-top: 1px solid var(--border-card);
      font-size: 0.85rem;
      color: var(--text-muted);

      a {
        color: var(--accent-blue);
        &:hover { text-decoration: underline; }
      }
    }

    @media (max-width: 768px) {
      .footer-grid { grid-template-columns: 1fr 1fr; gap: 32px; }
      .footer-brand { grid-column: 1 / -1; }
      .footer-bottom { flex-direction: column; gap: 8px; text-align: center; }
    }

    @media (max-width: 480px) {
      .footer-grid { grid-template-columns: 1fr; }
    }
  `,
})
export class FooterComponent {
  currentYear = new Date().getFullYear();
}
